import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/emissão-online.svg'
import _imports_1 from '@/assets/images/birdId-fast.gif'
import _imports_2 from '@/assets/images/CertificadoToken.svg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container p-4" }
const _hoisted_3 = { class: "breadcrumb-voucher py-3" }
const _hoisted_4 = { "aria-label": "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-7 mt-4 mt-lg-2" }
const _hoisted_10 = { class: "options_wrapper row" }
const _hoisted_11 = { class: "option col-lg" }
const _hoisted_12 = { class: "option col-lg" }
const _hoisted_13 = { class: "contact-wrapper" }
const _hoisted_14 = {
  class: "alert alert--notification",
  role: "alert"
}
const _hoisted_15 = { class: "alert__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_contact = _resolveComponent("contact")!
  const _component_ModalValidationBirdVue = _resolveComponent("ModalValidationBirdVue")!
  const _component_ModalSentDesktopVue = _resolveComponent("ModalSentDesktopVue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("nav", _hoisted_4, [
              _createElementVNode("ol", _hoisted_5, [
                _createElementVNode("li", _hoisted_6, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_icon, {
                        class: "color--info",
                        name: "house"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    class: "color--primary active fw-600",
                    to: "/"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("span", null, "Emissão de certificado", -1)
                    ])),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"col-lg-5\" data-v-e7b99e98><div class=\"text-start\" data-v-e7b99e98><div class=\"h-medium fw-400 pb-2\" data-v-e7b99e98><span class=\"fw-600 h-x-medium\" data-v-e7b99e98>Emissão Online</span><div class=\"mt-4\" data-v-e7b99e98>Emita ou Renove</div><div data-v-e7b99e98>seu <strong data-v-e7b99e98>Certificado</strong> de <br data-v-e7b99e98> forma <strong data-v-e7b99e98>simples</strong> e <strong data-v-e7b99e98>rápida</strong></div><img src=\"" + _imports_0 + "\" alt=\"icon-shield\" data-v-e7b99e98></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_9, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-start mb-4" }, [
                _createElementVNode("span", { class: "fs-5 color--primary" }, [
                  _createTextVNode("Escolha abaixo como deseja "),
                  _createElementVNode("strong", null, "emitir"),
                  _createTextVNode(" ou "),
                  _createElementVNode("strong", null, "renovar"),
                  _createTextVNode(" seu Certificado")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "btn option_button",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalValidationBird",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showRecaptcha && _ctx.showRecaptcha(...args)))
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("img", {
                      class: "option_image",
                      src: _imports_1,
                      alt: "icon-shield"
                    }, null, -1),
                    _createElementVNode("p", { class: "text-end option_text" }, [
                      _createTextVNode("Tenho um "),
                      _createElementVNode("strong", null, "Bird ID"),
                      _createTextVNode(" e desejo utilizar!")
                    ], -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "btn option_button",
                    ref: "btnTokenA3",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.isMobile ? _ctx.handleNavigate("tokenA3") : undefined))
                  }, _cache[7] || (_cache[7] = [
                    _createElementVNode("img", {
                      class: "option_image",
                      src: _imports_2,
                      alt: "icon-shield"
                    }, null, -1),
                    _createElementVNode("p", { class: "text-end option_text" }, [
                      _createTextVNode("Tenho um "),
                      _createElementVNode("strong", null, "token"),
                      _createTextVNode(" ou "),
                      _createElementVNode("strong", null, "cartão"),
                      _createTextVNode(" e desejo utilizar!")
                    ], -1)
                  ]), 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_contact)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ModalValidationBirdVue, {
        onLoadingStart: _cache[2] || (_cache[2] = () => { this.isLoadingHome = true; }),
        onLoadingEnd: _cache[3] || (_cache[3] = () => { this.isLoadingHome = false; })
      }),
      _createVNode(_component_ModalSentDesktopVue)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["cookies-alert", [_ctx.showCookiesAlert ? "d-block" : "d-none"]])
    }, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "alert-heading" }, "Cookies", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("div", null, [
            _createTextVNode("Utilizamos os cookies para melhorar sua experiência."),
            _createElementVNode("span", { class: "ms-1" }, "Para cumprir com a nova diretiva de privacidade, nós precisamos pedir seu"),
            _createTextVNode("consentimento para definir os cookies. Confira nossa"),
            _createElementVNode("a", {
              class: "color--light ms-1 text-decoration-underline",
              href: "/PoliticadeCookies.pdf",
              target: "_blank"
            }, "política de cookies. Saiba mais!")
          ], -1)),
          _createElementVNode("button", {
            class: "btn btn-light btn-sm mt-2",
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeAlert && _ctx.closeAlert(...args)))
          }, "Fechar")
        ])
      ])
    ], 2)
  ], 64))
}